import {log} from "console";

type ProgressEvent = {
    progressEvent: "Start" | "Fail" | "Complete";
    progressOne: string;
    score?: number;
    [key: string]: any;
}

export enum GameMode {
    NONE,
    TOURNAMENT,
    CHALLENGE
}

export class TimepassSDK {
    private static _instance: TimepassSDK | null = null;
    private _gaKey: string = "15902fdaf42366d77038d7ed9187f003";
    private _gaSecret: string = "960fdbee6032051dff8c69e04c2e461286840ba0"
    private _moengageAppID: string = "";
    timepassSDK: any = null;
    remoteState = {"bestscore": 0};
    localState = {"bestscore": 0};
    _isRemoteStateInitialized = false;
    localStorageStateKey = "PBCarrotRunState";
    _gamemode: GameMode = GameMode.NONE;

    public get GameMode(): GameMode {
        return this._gamemode;
    }

    public static getInstance(): TimepassSDK {
        if (!TimepassSDK._instance) {
            TimepassSDK._instance = new TimepassSDK();
        }
        return TimepassSDK._instance;
    }

    private constructor() {
        try {
            this.timepassSDK = window.timepass;
        } catch (error) {
            console.log(error);
        }
        console.log("window", window);
        console.log("window.timepass", window.timepass);
        console.log("this.timepassSDK", this.timepassSDK);
        console.log("TimepassSDK initialized 2");
        this.InitGameMode();
        this.PageReady();
        this.InitState();
        this.InitializeGameAnalytics();
        this.InitializeMoengage();
    }

    InitGameMode() {
        if (this.timepassSDK.getTournamentMode() == "true") {
            this._gamemode = GameMode.TOURNAMENT;
        } else if (this.timepassSDK.getChallengeMode() == "true") {
            this._gamemode = GameMode.CHALLENGE;
        }
    }

    async InitState() {
        this.InitLocalState();
        if (this.timepassSDK == null) {
            return;
        }
        let state = null;
        try {
            state = await this.timepassSDK.getState();
            console.log("GetState:");
            console.log(state);
            if (state != null && state.bestscore != null) {
                this.remoteState.bestscore = state.bestscore;
                this._isRemoteStateInitialized = true;
            }
        } catch (error) {
            console.log(error);
        }
        // if(this.localState.bestscore > this.remoteState.bestscore) {
        //     this.remoteState.bestscore = this.localState.bestscore;
        // }
        console.log("localState: " + this.localState.bestscore);
        console.log("remoteState: " + this.remoteState.bestscore);
    }

    InitializeMoengage() {
        this.ConfigureMoengageAppID();
    }

    InitializeGameAnalytics() {
        this.ConfigureAnalyticsUserID();
        this.timepassSDK.analytics.initializeGameAnalytics(this._gaKey, this._gaSecret);
        this.timepassSDK.analytics.enableGameAnalyticsLog()
    }

    ConfigureAnalyticsUserID() {
        this.timepassSDK.analytics.configureGameAnalyticsUserId(this.timepassSDK.getUserId());
    }

    ConfigureMoengagePlayerID(playerID: string): void {
        this.timepassSDK.analytics.sendMoengageUserLogin(playerID);
    }

    ConfigureMoengageAppID() {
        this.timepassSDK.analytics.initializeMoengage(this._moengageAppID);
    }

    async SendMoengageEvent(eventName: string, eventAttributes: any) {
        if (this.timepassSDK == null) {
            console.log("Unable to send moengage event");
            return;
        }
        try {
            await this.timepassSDK.analytics.sendMoengageTrackEvent(eventName, eventAttributes);
        } catch (error) {
            console.log("Unable to send moengage event");
            console.log(error);
        }
    }

    async ProgressionEvent(progress: ProgressEvent) {

        if (this.timepassSDK == null) {
            console.log("Unable to send progression event");
            return;
        }
        try {
            await this.timepassSDK.analytics.progressionEvent(progress)

        } catch (error) {
            console.log("Unable to send progression event");
            console.log(error);
        }

    }

    public async GetRemoteConfig(key: string, defaultValue: string) {
        return await this.timepassSDK.analytics.getRemoteConfigs(key, defaultValue);
    }

    InitLocalState() {
        const localData = window.localStorage.getItem(this.localStorageStateKey);
        if (localData != null) {
            const localJSON = JSON.parse(localData);
            if (localJSON != null && localJSON.bestscore != null && localJSON.bestscore > this.localState.bestscore) {
                this.localState.bestscore = localJSON.bestscore;
            }
        }
    }

    async SyncScore(score: number) {
        let retryCount = 4;
        while (retryCount > 0) {
            try {
                await this.timepassSDK.syncScore(score);
                break;
            } catch (error) {
                retryCount--;
            }
        }
        if (this.shouldSyncState(score)) {
            await this.SyncState(score);
        }
        this.syncLocalState(score);
    }

    syncLocalState(score: number) {
        let maxScore = 0;
        if (this._isRemoteStateInitialized == true) {
            maxScore = Math.max(this.remoteState.bestscore, score);
        } else {
            maxScore = Math.max(this.localState.bestscore, score);
        }
        this.localState.bestscore = maxScore;
        this.SaveLocalState();
    }

    shouldSyncState(score: number) {
        if (this._isRemoteStateInitialized == true) {
            return score > this.remoteState.bestscore;
        } else {
            return score > this.localState.bestscore;
        }
    }

    async SyncState(score: number) {
        try {
            this.remoteState.bestscore = score;
            await this.timepassSDK.syncState(this.remoteState);
        } catch (error) {

        }
    }

    SaveLocalState() {
        window.localStorage.setItem(this.localStorageStateKey, JSON.stringify(this.localState));
    }

    IsTournament() {
        return this._gamemode == GameMode.TOURNAMENT;
    }

    IsChallenge() {
        return this._gamemode == GameMode.CHALLENGE;
    }

    IsTimerType() {
        if (this.IsTournament()) return this.timepassSDK.getTournamentType() == "time";
        if (this.IsChallenge()) return this.timepassSDK.getChallengeType() == "time";
        return false;
    }

    IsChanceType() {
        if (this.IsTournament()) return this.timepassSDK.getTournamentType() == "chance";
        if (this.IsChallenge()) return this.timepassSDK.getChallengeType() == "chance";
        return false;
    }

    GetTime(): number {
        if (!this.IsTimerType()) return 0;
        if (this.IsTournament()) {
            return parseFloat(this.timepassSDK.getTournamentTime());
        } else if (this.IsChallenge()) {
            return parseFloat(this.timepassSDK.getChallengeTime());
        } else {
            return 0;
        }
    }

    SetGameChancesLeft(chancesCount: number) {
        this.timepassSDK.gameChanceLeft(chancesCount);
    }

    GetChances(): number {
        if (!this.IsChanceType()) return 0;
        try {
            let chances: number = 0;
            if (this.IsTournament()) {
                chances = parseInt(this.timepassSDK.getTournamentChances());
            } else if (this.IsChallenge()) {
                chances = parseInt(this.timepassSDK.getChallengeChances());
            } else {
                chances = 0;
            }
            if (Number.isNaN(chances)) return 0;
            return chances;
        } catch (error) {
            return 0;
        }
    }

    GameModeStarted() {
        console.log("TimepassSDK: gameStarted");
        this.timepassSDK.gameStarted();
    }

    GameModeFinished() {
        console.log("TimepassSDK: gameOver");
        this.timepassSDK.gameOver();
    }

    PageReady() {
        console.log("TimepassSDK: pageReady");
        this.timepassSDK.pageReady();
    }

    PlayerDisconnected() {
        console.log("TimepassSDK: playerDisconnected");
        this.timepassSDK.playerDisconnected();
    }

    ShowAds() {
        console.log("Ads");
        this.timepassSDK.showAds();
    }

    sendHapticFeedback() {
        this.timepassSDK.hapticFeedback(300);
    }

    showUserProfile(userId: string): void {
        this.timepassSDK.showUserProfile(userId);
    }


    exitClicked(): void {
        this.timepassSDK.exitGame();
    }




}